// import React, { useState, useRef, useEffect } from "react";
import React from "react";
import ChemistStoreComponent from "../tab-component/ChemistStoreComponent";

class selectedPharmacy extends React.Component<any, any> {

    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        return <ChemistStoreComponent
            navigation={this.props.navigation}
            route={this.props.route}
            selectedLocation={this.props.route.params?.selectedLocation} />
    }
}
export default selectedPharmacy;
